import React from 'react';
import { Form } from 'antd-mobile';
const ValueExpression = (props) => {
    const { valueFor, children, value } = props;
    let additionProps = {};
    if (typeof valueFor === 'function') {
        const mapResult = valueFor(value);
        if (typeof mapResult === 'string') {
            additionProps = { mapResult: value };
        }
        else if (typeof mapResult === 'object') {
            additionProps = mapResult;
        }
        else {
            additionProps = { value };
        }
    }
    else {
        const key = valueFor ? valueFor : 'value';
        additionProps = { [key]: value };
    }
    if (!Array.isArray(children)) {
        return children;
    }
    return children?.map((child, index) => {
        return React.cloneElement(child, {
            ...child,
            ...additionProps,
        });
    });
};
const ItemAdapter = (props) => {
    const { valueFor, name, children } = props;
    return (React.createElement(Form.Item, { noStyle: true, name: name },
        React.createElement(ValueExpression, { valueFor: valueFor, children: children })));
};
export default ItemAdapter;
